module.exports = __webpack_public_path__ + "img/02-04-img-05@2x.0956528c.png";